module.exports = __webpack_public_path__ + "static/media/mediterrean-diet-min.de5039a1.png";